import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'ljit-store-connecter';
import NewVersionNotice from '../components/new-version-notice';
import AuthRoute from './auth-route';
import I18nRoute from './i18n-route';
import LayoutRoute from './layout-route';
import './styling/style.styl';

const propTypes = {
	platformSetting: PropTypes.object,
};

function App({
	platformSetting,
}) {
	const { favicon = {} } = platformSetting;
	const { metadata: { Location: url } = {} } = favicon;

	function _renderRoute(auth) {
		return <I18nRoute
			render={() => <LayoutRoute auth={auth}/>}
		/>;
	}

	return (
		<div>
			<Helmet>
				<link rel="icon" href={url} />
			</Helmet>
			<AuthRoute
				render={auth => _renderRoute(auth)}
			/>
			<NewVersionNotice />
		</div>
	);
}

App.propTypes = propTypes;

function mapStateToProps(state) {
	return {
		platformSetting: state.platformSetting.get('data').toObject(),
	};
}

function mapDispatchToProps() {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
